export const translations = {
	'Selected assets': {
		no: 'Valgte ressurser',
	},
	'Add to assetgroup': {
		no: 'Legg til ressursgruppe',
	},
	'Remove from assetgroup': {
		no: 'Fjern fra ressursgruppe',
	},
	'External assets': {
		no: 'Eksterne ressurser',
	},
	'Move to selected assets': {
		no: 'Legg til valgte ressurser',
	},
	'Update interval': {
		no: 'Oppdateringintervall',
	},
	'Load events': {
		no: 'Last hendelse',
	},
	'Delay grid update with {0} seconds': {
		no: 'Utsett tabelloppdatering med {0} sekunder',
	},
	'System icons': {
		no: 'System ikoner',
	},
	'Uploaded images': {
		no: 'Opplastete bilder',
	},
	'Best resolution for logo is 120px width by 40px height': {
		no: 'Best oppløsning er 120 X 40 px for logobilde',
	},
	'Only .jpg, .jpeg and .png files can be uploaded': {
		no: 'Bare .jpg, .jpeg og .png filer kan lastes.',
	},
	'The file must be less than 1 MB.': {
		no: 'Filen må være mindre enn 1 MB.',
	},
	'The image will be removed from all places it is used. Are you sure you want to delete?': {
		no: 'Bildet vil bli fjernet fra hvert sted det brukes. Er du sikker på at du vil slette den?',
	},
	'From and To time cannot be edited in a historic period': {
		no: 'Fra og til tid kan ikke endres for historisk periode',
	},
	'Set as default': {
		no: 'Sett som standard',
	},
	'Bundles will be installed for selected agents.': {
		no: 'Pakkene vil bli lastet opp på valgte agenter',
	},
	'Bundles will be uninstalled from selected agents.': {
		no: 'Pakkene vil bli avinstallert på valgte agenter',
	},
	'Bundle was successfully installed': {
		no: 'Pakke ble installert',
	},
	'Bundle was successfully uninstalled': {
		no: 'Pakke ble avinstallert',
	},
	'Bundles were successfully installed': {
		no: 'Pakkene ble installert',
	},
	'Bundles were successfully uninstalled': {
		no: 'Pakkene ble avinstallert',
	},
	'Tags has been successfully set': {
		no: 'Etikett er satt',
	},
};
